import {
  GET_GREETING_START,
  GET_GREETING_ERROR,
  GET_GREETING_SUCCESS,
  UPDATE_GREETING_START,
  UPDATE_GREETING_ERROR,
  UPDATE_GREETING_SUCCESS,
} from '../constants';

import getGreetingQuery from './queries/getGreeting.graphql';
import updateGreetingMutation from './mutations/updateGreeting.graphql';

// TODO: Consistent error handling

export function getGreeting(token) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: GET_GREETING_START,
      payload: {
        greetingLoading: true,
      },
    });
    try {
      const {
        data: {
          greetings: { byToken },
        },
        errors,
      } = await client.query({
        query: getGreetingQuery,
        variables: {
          token,
        },
        context: {
          service: 'graphqlHost',
        },
      });
      if (errors && errors.length) {
        dispatch({
          type: GET_GREETING_ERROR,
          payload: {
            errors: errors.map(err => err.message),
            greetingLoading: false,
          },
        });
      } else {
        dispatch({
          type: GET_GREETING_SUCCESS,
          payload: {
            data: {
              ...byToken,
            },
            greetingLoading: false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: GET_GREETING_ERROR,
        payload: {
          errors: [error].map(e => e.message),
          greetingLoading: false,
        },
      });
    }
    const state = getState();
    return state && state.greeting ? state.greeting : {};
  };
}

export function updateGreeting(greeting) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: UPDATE_GREETING_START,
      payload: {
        greetingLoading: true,
      },
    });
    try {
      const {
        data: {
          greetings: { update },
        },
        errors,
      } = await client.mutate({
        mutation: updateGreetingMutation,
        variables: {
          greetingInput: greeting,
        },
        context: {
          service: 'graphqlHost',
        },
      });
      if (errors && errors.length) {
        dispatch({
          type: UPDATE_GREETING_ERROR,
          payload: {
            errors: errors.map(err => err.message),
            greetingLoading: false,
          },
        });
      } else {
        dispatch({
          type: UPDATE_GREETING_SUCCESS,
          payload: {
            greeting: {
              ...update,
            },
            greetingLoading: false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_GREETING_ERROR,
        payload: {
          errors: [error].map(e => e.message),
          greetingLoading: false,
        },
      });
    }
    const state = getState();
    return state && state.greeting ? state.greeting : {};
  };
}
